import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { UserDtoSchema } from '../contracts';

const GetOrgAdminsResponseDtoSchema =
  PagePaginationResponseDtoSchema(UserDtoSchema);

export type GetOrgAdminsRequestDto = PagePaginationRequestDto<
  { search?: string },
  'createdAt' | 'lastLogin' | 'fullName'
>;
export type GetOrgAdminsResponseDto = z.infer<
  typeof GetOrgAdminsResponseDtoSchema
>;

// Super-admin only — lists organization admins across all orgs so LIAC access can
// be granted/revoked from Settings → Users.
export const getOrgAdmins = (
  params: GetOrgAdminsRequestDto,
  config?: AxiosRequestConfig<GetOrgAdminsRequestDto>
) => {
  return api
    .get('/users/org-admins', { params, ...config })
    .then(responseContract(GetOrgAdminsResponseDtoSchema));
};
